// extracted by mini-css-extract-plugin
export default {"ibwConversionContainer":"IBWConversion__ibwConversionContainer","price":"IBWConversion__price"};